<template>
  <div class="home">
    <router-view class="container"></router-view>
    <van-tabbar class="footer" v-model="activeMenu">
      <van-tabbar-item
        v-for="item in menus"
        :key="item.path"
        :name="item.label"
        replace
        :to="`/${item.path}`"
      >
        <span>{{ item.label }}</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? item.active_imgUrl : item.normal_imgUrl"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "layout",
  components: {},
  data() {
    return {
      activeMenu: "",
      menuArr: [
        {
          label: "首页",
          path: "home",
          active_imgUrl: require("../assets/layout/home_active.png"),
          normal_imgUrl: require("../assets/layout/home_normal.png"),
          ismennu: true
        },
        {
          label: "客户",
          path: "custom",
          active_imgUrl: require("../assets/layout/custom_active.png"),
          normal_imgUrl: require("../assets/layout/custom_normal.png"),
          ismennu: true
        },
        {
          label: "报表",
          path: "reports",
          active_imgUrl: require("../assets/layout/reports_active.png"),
          normal_imgUrl: require("../assets/layout/reports_normal.png"),
          ismennu: true
        },
        {
          label: "个人中心",
          path: "person",
          active_imgUrl: require("../assets/layout/person_active.png"),
          normal_imgUrl: require("../assets/layout/person_normal.png"),
          ismennu: true
        }
      ],
      menus: []
    };
  },
  computed: {
    JobCode() {
      return this.$store.getters.indexSystemType
        ? this.$store.getters.indexSystemType.JobCode
        : "";
    }
  },
  watch: {
    JobCode(val) {
      this.setMenus();
    },
    $route: {
      handler: function(to, from) {
        this.activeMenu = to.matched[1].name || '';
        if (to.path == "/custom") {
          localStorage.removeItem("customFilterCache");
        }
      },
      deep: true
    }
  },
  mounted() {
    this.activeMenu = this.$route.matched[1].name || '';
    this.setMenus();
  },
  methods: {
    setMenus() {
      console.log(this.JobCode);
      let menus = [];
      this.menuArr.map(item => {
        if (this.JobCode == "fj" && item.label == "客户") {
        } else {
          menus.push(item);
        }
      });
      console.log(menus);
      this.menus = Object.assign({}, menus);
    }
  }
};
</script>
<style lang="less">
.home {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  height: 100%;

  > .container {
    box-sizing: border-box;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    overflow: auto;
  }
  > .footer {
    position: relative;
    .van-tabbar-item {
      color: #999999;
      .van-tabbar-item__icon {
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        margin-bottom: 3px;
        img {
          width: 100%;
          height: auto;
        }
      }
      &.van-tabbar-item--active {
        color: #666666;
      }
    }
  }
}
</style>
